import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-410f8a0f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "message-icon"
};
const _hoisted_2 = {
    key: 1,
    class: "message-image"
};
const _hoisted_3 = { class: "message-default-content" };
const _hoisted_4 = {
    key: 0,
    class: "title"
};
const _hoisted_5 = { class: "message" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["message-box message-border", `message-box-${_ctx.variant}`])
    }, [
        _createElementVNode("div", {
            class: _normalizeClass(["message-content", { 'with-icon': _ctx.$slots['icon'], 'with-image': _ctx.$slots['img'] }])
        }, [
            (_ctx.$slots['icon'] && !_ctx.$slots['img'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _renderSlot(_ctx.$slots, "icon", {}, undefined, true)
                ]))
                : _createCommentVNode("", true),
            (_ctx.$slots['img'] && !_ctx.$slots['icon'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "img", {}, undefined, true)
                ]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_3, [
                (_ctx.title)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.title), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.$slots['message'])
                        ? _renderSlot(_ctx.$slots, "message", { key: 0 }, undefined, true)
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createTextVNode(_toDisplayString(_ctx.message), 1)
                        ], 64))
                ])
            ])
        ], 2)
    ], 2));
}
